import { useContext } from "react";
import { FilteredTagsStateContext } from "src/context/FilteredTagsStateContext";

export const useFilteredTags = () => {
  const context = useContext(FilteredTagsStateContext);

  if (context === undefined) {
    throw new Error("useFilteredTags must be used within an FilteredTagsState");
  }

  return context;
};
